import mountReactApp from 'src/utils/mountReactApp'
import { installPledge } from 'src/widgets/plugins/pledge'
import InputField from 'src/widgets/donate_v7/InputField'
import CheckBox from 'src/widgets/donate_v7/CheckBox'
import SelectField from 'src/widgets/donate_v7/SelectField'
import App from 'src/widgets/donate_v7/App'
import 'src/widgets/donate_v6/backToSearch'
import 'src/widgets/donate_v6/openModalTriggers'
import 'src/widgets/donate_v6/standaloneAbandonedCart'

// Public plugin API (window.Pledge) with v7's Tailwind components. Must run
// before any plugin <script> registers via Pledge.widget.addPlugin. v7 has no
// legacy root-event plugins, so no bridge is needed (unlike v6).
installPledge({ version: 7, components: { InputField, CheckBox, SelectField } })

mountReactApp(App)
